/**
 * Идентификаторы, работающие в любом контексте.
 *
 * `crypto.randomUUID` доступен только в защищённом контексте: по https или
 * на localhost. На домене, открытом по http (локальный стенд, проверка
 * с соседней машины по адресу вида datahunter.local), его просто нет, и
 * обращение к нему роняет страницу целиком: редактор не гидратируется и
 * человек видит «что-то пошло не так» вместо рабочего поля.
 *
 * Уникальность здесь нужна в пределах одной комнаты и одного браузера, а
 * не глобально, поэтому запасной вариант из времени и случайного хвоста
 * полностью достаточен.
 */
export function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // getRandomValues доступен и в незащищённом контексте, в отличие от
  // randomUUID: используем его, пока он есть.
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
